import { render, staticRenderFns } from "./JekList.vue?vue&type=template&id=0397f98b"
import script from "./JekList.vue?vue&type=script&lang=js"
export * from "./JekList.vue?vue&type=script&lang=js"
import style0 from "./JekList.vue?vue&type=style&index=0&id=0397f98b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports